import { useAppSelector } from '../../app/hooks';
import { selectSessionBankCode, selectSessionBankName } from '../../app/slices/bank.slice';

export const useBank = () => {
	const bankName = useAppSelector(selectSessionBankName) as string;
	const bankCode = useAppSelector(selectSessionBankCode) as string;

	return { bankName, bankCode };
};
